import { MasterData } from "@core/models/master-data/master-data";

export class storeMasterDataAction {
    static readonly type = '[MasterData] MasterData';

    constructor(public payload: MasterData) {
    }
}